// Utility to check if string contains HTML tags
export const isHtml = (str: string): boolean => {
  return /<[^>]+>/.test(str);
};

// Utility to strip HTML tags, decode entities, and add space after '.' or '?'
export const htmlToPlainText = (html: string): string => {
  // Replace <br> and <br/> with newlines
  let text = html.replace(/<br\s*\/?>(?!,)/gi, "\n");
  // Replace all </li> except the last one with ', '
  text = text.replace(/<\/li>(?=(.|\n)*<\/li>)/gi, ", ");
  // Remove all other HTML tags
  text = text.replace(/<[^>]+>/g, "");
  // Decode common HTML entities
  text = text
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
  // Add a space after '.' or '?' if not already followed by a space or newline
  text = text.replace(/([.?])(?![ \n])/g, "$1 ");
  return text;
};
